import React, { useEffect, useState, useCallback } from 'react';
import { getCharacterImages } from './styleFunctions';
import { Bubble, SpeechBubbleBefore, SpeechBubbleAfter } from './styles';

const ExerciseBubble = ({ exerciseName, levels, imageId, isMobile }) => {
  const [bubbleCoordinates, setBubbleCoordinates] = useState({ left: 0, right: 0, bottom: 0, isRight: false });

  const updateBubblePosition = useCallback(() => {
    const startElement = document.getElementById(imageId);
    if (!startElement) return;
    const { offsetHeight: elementHeight } = startElement;
    const styleOfImage = getCharacterImages(levels.length);
    const newCoordinates = {
      bottom: elementHeight + 10,
      left: styleOfImage.hasOwnProperty('left') ? styleOfImage.left + 10 : undefined,
      right: styleOfImage.hasOwnProperty('right') ? styleOfImage.right + 20 : undefined,
      isRight: styleOfImage.hasOwnProperty('right') ? true : false,
    };
    setBubbleCoordinates(newCoordinates);
  }, [levels.length, imageId]);

  useEffect(() => {
    if (document.getElementById(imageId)?.complete) {
      updateBubblePosition();
    }
  }, [updateBubblePosition, imageId]);

  useEffect(() => {
    const handleResize = () => updateBubblePosition();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [updateBubblePosition]);

  return (
    <Bubble {...bubbleCoordinates} isMobile={isMobile}>
      {exerciseName}
      <SpeechBubbleBefore isRight={bubbleCoordinates.isRight} />
      <SpeechBubbleAfter isRight={bubbleCoordinates.isRight} />
    </Bubble>
  );
};

export default ExerciseBubble;
